// Helpers shared between the set-page card views (SetCardsTable, SetCardsList).

// Rarity color mapping (matches SetCardsGrid)
export const rarityColors: Record<string, string> = {
  common: '#1a1a1a',
  uncommon: '#707883',
  rare: '#a58e4a',
  mythic: '#bf4427',
  special: '#905d98',
  bonus: '#905d98',
};

// Format rarity for display
export const formatRarity = (rarity: string): string => {
  return rarity.charAt(0).toUpperCase() + rarity.slice(1).toLowerCase();
};

// Parse collector number for numeric sorting
export const parseCollectorNumber = (cn: string): { numeric: number; suffix: string } => {
  const match = cn.match(/^(\d+)(.*)$/);
  if (match) {
    return { numeric: parseInt(match[1], 10), suffix: match[2] || '' };
  }
  return { numeric: Infinity, suffix: cn };
};
